'use client'; // Asegúrate de que esté al principio del archivo
import React from 'react';  // Importa React si no está importado
import Head from 'next/head';  
const topics = [
  {
    id: 'support-artists',
    label: 'Support Artists to Build up Their Talent',
  },
  {
    id: 'invest-in-culture',
    label: 'Invest in Cultural Progress',
  },
  {
    id: 'support-social-movements',
    label: 'Support Social Movements through Art',
  },
  {
    id: 'commission-art',
    label: 'Commission Art According to Your Needs',
  },
];

// Definir un componente Section para reutilizar
const Section = ({ id, title, content = [], imgSrc, imgAlt }) => (
  <div id={id} className="mt-10">
    <h3 className="text-2xl font-bold dark:text-blue-100 text-neutral-950">{title}</h3>
    <div className="dark:text-gray-300 text-neutral-800 text-base mt-2">
      {content.map((para, index) => (
        <p key={index} className="mt-2">
          {para}
        </p>
      ))}
    </div>
    <div className="grid min-h-[140px] w-full place-items-center overflow-x-scroll rounded-lg p-6 lg:overflow-visible">
      <img className="object-cover object-center w-full h-96" src={imgSrc} alt={imgAlt} />
      <p className="mt-2 text-sm text-gray-600">{imgAlt}</p>
    </div>
  </div>
);


  const BuyArtworksFromNewArtists = ({
    // Propiedades dentro del componente
    title = "Buy Artworks from New Artists",
    description = "A deep dive into supporting new artists and purchasing their artworks.",
    category = ["Arts", "Technology"],
    tags = ["Art", "Artists", "Support", "New Artists"],
  }) => {
    // Objeto article dentro del componente
    const article = {
      imageUrl: "https://storage.googleapis.com/drago-imagenes-bucket/BuyArtworksFromArtistsnew.webp",
    };

  return (
    <>
    <Head>
      <title>Unique Ways to Support Emerging Artists: Why Buying Their Art Matters for the Future</title>
      <meta name="description" content="Discover unique ways to support emerging artists by buying their artwork. Learn how your contribution helps foster creativity, innovation, and the growth of the art world, ensuring a vibrant future for new talent." />
      <meta name="author" content="dravvt" />
      
      {/* Meta para redes sociales */}
      <meta property="og:title" content="Unique Ways to Support Emerging Artists: Why Buying Their Art Matters for the Future" />
      <meta property="og:description" content="Discover unique ways to support emerging artists by buying their artwork. Learn how your contribution helps foster creativity, innovation, and the growth of the art world, ensuring a vibrant future for new talent." />
      <meta property="og:image" content="https://storage.googleapis.com/drago-imagenes-bucket/BuyArtworksFromArtistsnail.webp" />
      <meta property="og:url" content="https://dravvt.com/blog/buy-artworks-from-new-artists" />
      
      {/* Meta para Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Unique Ways to Support Emerging Artists: Why Buying Their Art Matters for the Future" />
      <meta name="twitter:description" content="Discover unique ways to support emerging artists by buying their artwork. Learn how your contribution helps foster creativity, innovation, and the growth of the art world, ensuring a vibrant future for new talent." />
      <meta name="twitter:image" content="https://storage.googleapis.com/drago-imagenes-bucket/BuyArtworksFromArtistsnail.webp" />
      <meta name="twitter:url" content="https://dravvt.com/blog/buy-artworks-from-new-artists" />
    </Head>
    <div>
      <div className="dark:bg-gray-900 bg-transparent border border-neutral-950 text-neutral-950 p-4 rounded-lg shadow-md mb-4 max-w-xs mx-auto text-xs dark:text-gray-400 flex flex-col space-y-2">
        <h1 className="text-lg font-bold text-neutral-950 dark:text-white">{title || 'Default Title'}</h1>
        <p className="font-medium text-orange-600 dark:text-orange-400">Category: {category.join(', ')}</p>
        <p className="dark:text-gray-300 text-neutral-700">{description}</p>
        <p className="font-medium text-blue-500">Tags: {tags.join(', ')}</p>
      </div>
      <div className="article-content">
        <div className="max-w-screen-xl mx-auto p-5 sm:p-8 md:p-12 relative">
          <div
            className="bg-cover bg-center h-64 text-center overflow-hidden"
            style={{
              height: '450px',
              backgroundImage: `url(${article.imageUrl})`,
            }}
          ></div>
          <div className="max-w-2xl mx-auto">
            <div className="mt-3 bg-transparent rounded-b lg:rounded-b-none lg:rounded-r flex flex-col justify-between leading-normal">
              <a href="#" className="text-base text-blue-600 dark:text-gray-100 uppercase font-medium transition duration-500 ease-in-out">
                Arts
              </a>
              ,{' '}
              <a href="#" className="text-xs text-blue-600 dark:text-gray-100 uppercase font-medium transition duration-500 ease-in-out">
                Technology
              </a>
              <p></p>
              <p className="dark:text-gray-500 text-neutral-700 text-xs mt-2">Written By: Dravvt</p>
              <div className="dark:bg-gray-900 bg-transparent border border-neutral-950 p-4 rounded-lg shadow-md mb-4 max-w-md mx-auto text-base text-gray-400 flex flex-col space-y-2">
    <h3 className="text-lg font-semibold text-neutral-950 dark:text-blue-100 mb-3">
      Topics Covered:
    </h3>
    <ul className="list-disc pl-5">
      {topics.map((topic) => (
        <li key={topic.id}>
          <a
            href={`#${topic.id}`}
            className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600"
          >
            {topic.label}
          </a>
        </li>
      ))}
    </ul>
  </div>



              <Section
                id="support-artists"
                title="#1. Support Artists to Build Up Their Talent"
                content={[
                  'Artists are the lifeblood of our society, constantly pushing the boundaries of creativity and challenging conventional thinking. Their work inspires change, evokes emotion, and reflects the complexities of human experience, making art an essential part of our cultural fabric.',
                  'One of the most impactful ways to support artists is by purchasing their artworks. By investing in their creations, you not only provide financial stability but also contribute to the growth of their careers and the continuation of their artistic practices.',
                  '',
                  'Another way to support artists is by attending art shows and exhibitions. These events allow you to experience their work firsthand, engage with their creative process, and provide direct exposure to potential buyers or collaborators, helping them build their audience and reputation.',
                  'In conclusion, supporting artists is not only vital for the growth and diversity of the art world but also for the enrichment of society as a whole. By investing in their work, whether through purchasing art, attending events, or providing other forms of support, we contribute to a thriving creative economy that benefits everyone.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/Support-Artists-to-Build-up-Their%20-Talent..jpeg"
                imgAlt="Two people working together to create a sculpture..."
              />

              <Section
                id="invest-in-culture"
                title="#2. Invest in Cultural Progress"
                content={[
                  'Culture and art are inextricably linked, as they both shape and reflect the values of society. Art has always been a catalyst for societal transformation, influencing political, social, and cultural change. Moreover, artists possess the unique ability to touch the emotions of individuals, transcending barriers and making connections across different backgrounds and experiences.',
                  'Furthermore, investing in art is not just about acquiring beautiful works; it is an investment in humanity itself. By supporting artists, we contribute to the preservation and evolution of cultural expressions, which are vital for our collective identity and heritage. In doing so, we ensure the continuation of a rich cultural landscape for future generations.',
                  'In summary, by investing in cultural progress, we not only contribute to the survival and flourishing of the arts but also foster a more vibrant, innovative, and thoughtful society. Through our support, we help shape a future where art plays a central role in nurturing creativity, social progress, and human connection.'
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/Invest-in-culture-progress.jpeg"
                imgAlt="A symbolic image showing plants growing from coins..."
              />

              <Section
                id="support-social-movements"
                title="#3. Support Social Movements Through Art"
                content={[
                  'Supporting emerging artists not only helps them refine their craft but also provides them with the platform to express their ideas and perspectives.',
                  'Art is inherently semi-autonomous, offering artists the freedom to challenge societal norms and provoke important conversations.',
                  'Moreover, many contemporary artists are actively engaged in social activism, using their work to address pressing social issues such as inequality, climate change, and human rights.',
                  'When you invest in art from new and emerging artists, you are not only supporting their personal growth but also contributing to the broader movements they are part of, which can inspire change and influence public discourse.'
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/Support-Social-Movements-through-art.jpeg"
                imgAlt="A group of people looking at the world from the outside..."
              />

              <Section
                id="commission-art"
                title="#4. Commission Art According to Your Needs"
                content={[
                  'Many artists are open to commissions, offering a personalized experience to bring your vision to life.',
                  'If you have a particular idea in mind, working directly with an artist can help you create a custom piece that perfectly reflects your tastes and preferences.',
                  'Alternatively, if you find an existing piece that resonates with you, commissioning an artist to create something similar can provide a unique interpretation of your idea.',
                  'Commissioning artwork not only provides you with a one-of-a-kind piece for your collection but also fosters a meaningful connection between you and the artist.',
                  'Additionally, commissioning artwork from new artists gives them the opportunity to showcase their talents and gain valuable experience in their craft.'
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/Commission-Art-according-to-Your-Needs.jpeg"
                imgAlt="Two people exchanging something..."
              />

              <Section
                id="conclusion"
                title="#5. Conclusion"
                content={[
                  'In conclusion, supporting new artists and investing in their work is not just about acquiring art but about nurturing creativity and culture.',
                  'By supporting emerging talent, we contribute to a vibrant and diverse art world that continues to evolve and inspire.',
                  'Art is a powerful tool for social change, and by commissioning, buying, or supporting artists, we help amplify voices and perspectives that deserve to be heard.',
                  'Whether through direct investment or encouraging cultural progress, every action taken helps shape the future of art and its impact on society.',
                  'In the end, your support has the power to make a lasting difference, fostering a community where creativity thrives.'
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/Conclusion-supporting-artists-is-not-just-about-acquiring-art.webp"
                imgAlt="A person viewing a piece of art that represents growth and transformation."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};



export default BuyArtworksFromNewArtists;

